module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_artefacts.890d6bd6.jpg";